import toast from '@/libs/cifra/toast';
import { t } from '@/libs/i18n';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    this.element.addEventListener('submit', (e) => {
      const campos = this.element.querySelectorAll('#campos_listado input[type="checkbox"]');
      // Hay listados que no tienen selección de campos porque son listados fijos
      if (campos.length > 0) {
        const camposSeleccionados = this.element.querySelectorAll('#campos_listado input[type="checkbox"]:checked');
        if (camposSeleccionados.length < 1) {
          toast.error(t('debe_seleccionar_un_campo'));
          e.preventDefault();
        }
      }
    });
  }
}
